<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-data-filter`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.98647 1.54093C4.28388 1.54093 1.26988 2.71133 1.26988 4.56263C1.26988 5.16178 1.58629 5.72726 2.13831 6.21533L6.29867 10.3757V13.4287C6.29867 14.0463 7.04761 14.5462 7.97494 14.5462C8.90059 14.5462 9.6512 14.0463 9.6512 13.4287V10.3807L13.8637 6.16821C13.9395 6.09752 14.0118 6.02684 14.0792 5.95278L14.1078 5.92417C14.1347 5.89724 14.1566 5.86863 14.1785 5.84171C14.5033 5.44788 14.6817 5.01704 14.6817 4.56431C14.68 2.71133 11.6891 1.54093 7.98647 1.54093Z" :fill="useCurrentColor ? 'currentColor' : '#165DFF'"/><ellipse cx="7.976" cy="4.475" rx="5.279" ry="2.13" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconColorDataFilter',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
